import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import { format } from "date-fns";
import fileDownload from "js-file-download";
import { useSnackbar } from "notistack";
import { v4 as uuid } from "uuid";

import InviteDialog from "../../components/dialogs/inviteDialog";

import constants from "../../assets/constants";
import * as OmniDataAPI from "../../data/omniDataAPI";
import { createNewInvite } from "../../data/omniDataModel";
import * as AdminSessionActions from "../../state/redux/adminSession";
import * as OnboardingSessionActions from "../../state/redux/onboardingSession";
import { deepCopyObject } from "../../utils/helpers";
import { generateCSVData } from "../../utils/helpers";
import AlertDialog from "../dialogs/alertDialog";
import BulkInviteDialog from "../dialogs/bulkInviteDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import SurveyInvites from "../ui/surveyInvites";
import Widget from "../ui/widget";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetSurveyContent from "../ui/widgetSurveyContent";
import WidgetTitle from "../ui/widgetTitle";

const AdminSingleInvites = props => {
  const {
    singleInviteODMs,
    reflectUpdatedInviteODMRequest,
    loadSingleInvitesRequest,
    onboardingStatus,
    singleInvitePageLoading,
    singleInvitePagination,
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (singleInviteODMs != null) {
      setRows(singleInviteODMs);
    }
  }, [singleInviteODMs]);

  useEffect(() => {
    if (onboardingStatus != null) {
      // this is broke for creating Provider type onboards
      try {
        if (onboardingStatus.errorCode === "200") {
          enqueueSnackbar(onboardingStatus.errorText, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(onboardingStatus.errorText, {
            variant: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }

      props.setOnboardingStatusRequest(null);
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onboardingStatus, enqueueSnackbar]);

  const [rows, setRows] = useState([]);

  const [titleText, setTitleText] = useState(null);
  const [deleteInvite, setDeleteInvite] = useState(null);
  const [createReport, setCreateReport] = useState(null);
  const [deleteSelections, setDeleteSelections] = useState(null);

  const [selectedInvite, setSelectedInvite] = useState(null);

  const [showCampaign, setShowCampaign] = useState(false);
  const [campaign, setCampaign] = useState("");
  const [groupSize, setGroupSize] = useState(null);

  const [onboardingHTML, setOnboardingHTML] = useState("");
  const [onboardingAssessmentType, setOnboardingAssessmentType] = useState("");

  const [importFile, setImportFile] = useState(null);

  const [importRows, setImportRows] = useState([]);
  const [importPageNum, setImportPageNum] = useState(0);

  const [importError, setImportError] = useState(false);
  const [importResult, setImportResult] = useState(null);

  const handleOnImportFileSelected = e => {
    setImportFile(e.target.files[0]);
    e.target.value = null;
  };

  useEffect(() => {
    if (importResult != null && importRows.length === 0) {
      let downloadData = [
        {
          successCount: importResult.numberOfSuccess,
          errorsCount: importResult.numberOfErrors,
          errors: "",
        },
      ];
      for (const property in importResult.errors) {
        downloadData.push(property);
      }
      fileDownload(
        generateCSVData(downloadData),
        `${importFile.name.slice(0, importFile.name.length - 4)}_results_${format(
          new Date(),
          "yyMMdd_hhmmss",
        )}.csv`,
      );

      clearState();
      let newPad = deepCopyObject(singleInvitePagination);
      newPad.invalidateCache = true;

      loadSingleInvitesRequest(newPad);
    }
  }, [importResult, importRows, importFile, loadSingleInvitesRequest, singleInvitePagination]);

  useEffect(() => {
    if (importRows.length > 0) {
      if (importPageNum === 0) {
        enqueueSnackbar("Starting Import (Do not refresh this page!)", {
          variant: "info",
        });
        setImportPageNum(1); //this should trigger updates
      } else {
        //process
        //a2K here is the place where we use add the Groups

        const bulkPageSize = 500;
        let pageStartIndex = (importPageNum - 1) * bulkPageSize;

        if (pageStartIndex >= importRows.length) {
          //Set Complete flag/state
          enqueueSnackbar("Import Completed Successfully", {
            variant: "success",
          });
          setImportRows([]);
        } else {
          //copy UPTO next page index, Zero-based index at which to end extraction
          //its ok if its longer than then end of the array
          let inviteODMs = importRows.slice(pageStartIndex, importPageNum * bulkPageSize);

          OmniDataAPI.createBulkInvites(inviteODMs).then(theResult => {
            //set results

            if (theResult == null) {
              enqueueSnackbar("Call failed with Error", {
                variant: "error",
              });
              setImportRows([]);
            } else if (theResult.hasOwnProperty("numberOfSuccess")) {
              if (importPageNum % 2 === 0) {
                enqueueSnackbar(`${importPageNum * bulkPageSize} total invites created...`, {
                  variant: "info",
                });
              }

              setImportResult(prev => {
                if (prev == null) {
                  return theResult;
                } else {
                  let newResult = {
                    numberOfSuccess: theResult.numberOfSuccess + prev.numberOfSuccess,
                    numberOfErrors: theResult.numberOfErrors + prev.numberOfErrors,
                    errors: { ...theResult.errors, ...prev.errors },
                  };

                  return newResult;
                }
              });
              //set new page number
              setImportPageNum(prev => prev + 1);
            } else {
              //set new page number

              enqueueSnackbar(theResult, {
                variant: "error",
              });
              setImportRows([]);
            }
          });
        }
      }
    } else {
      setImportPageNum(0);
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [importRows, importPageNum]);

  useEffect(() => {
    if (importFile) {
      if (campaign && groupSize) {
        let fileReader = new FileReader();
        fileReader.onload = event => {
          processImportFile(
            event.target.result,
            campaign,
            groupSize,
            onboardingHTML,
            onboardingAssessmentType,
          );
        };
        fileReader.readAsText(importFile);
      } else {
        setShowCampaign(true);
      }
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaign, groupSize, importFile, setImportPageNum, setImportRows]);

  const formatPhoneNumber = phoneNumber => {
    let phoneNum = phoneNumber;
    if (phoneNum) {
      phoneNum = phoneNum.toString().replaceAll(/\D/gi, "");
      phoneNum = `(${phoneNum.substring(0, 3)})${phoneNum.substring(3, 6)}-${phoneNum.substring(
        6,
      )}`;
    }

    return phoneNum;
  };

  const processImportFile = (
    string,
    campaign,
    groupSize,
    onboardingHTML,
    onboardingAssessmentType,
  ) => {
    let array = string.toString().replaceAll("\r", "").split("\n");
    let data = [];

    if (array.length <= 1 || (array.length > 1 && array[0].includes("omni"))) {
      enqueueSnackbar("Bad Columns, Aborting", {
        variant: "error",
      });
      clearState();
    } else if (
      array[0].includes("givenName") &&
      array[0].includes("familyName") &&
      array[0].includes("mobilePhone") &&
      array[0].includes("email")
    ) {
      for (const r of array) {
        let row = r
          .toString()
          .split(",")
          .reduce((arr, currObj) => {
            arr.push(currObj.trim());
            return arr;
          }, []);
        if (row.length >= 4) {
          data.push(row);
        }
      }

      let heading = data[0].concat("_id");
      let invArray = [];

      let groupSuffix = "";
      for (let i = 1; i < data.length; i++) {
        let row = data[i];
        let obj = {};
        for (let j = 0; j < heading.length; j++) {
          if (!row[j]) {
            row[j] = "";
          }
          obj[heading[j]] = row[j];
        }

        if (groupSize < 1000000) {
          let suffix = Math.floor(i / groupSize); //what page we are on
          suffix = suffix * groupSize;
          groupSuffix = `_${suffix.toString().padStart(4, "0")}+${groupSize}`;
        }
        // Create new Invite
        let newObj = createNewInvite(constants.onboardingUserType.partner);

        // Seed Invite
        newObj.omniData.userData.givenName = obj.givenName;
        newObj.omniData.userData.familyName = obj.familyName;
        newObj.omniData.userData.email = obj.email;
        // newObj.omniData.target = campaign;old school
        newObj.omniData.target = campaign + groupSuffix;
        newObj.omniData.onboardingHTML = onboardingHTML;
        newObj.omniData.onboardingAssessmentType = onboardingAssessmentType;

        //And Stems
        let now = new Date();
        newObj.omniData.sentDatetime = now.toISOString();
        now.setDate(now.getDate() + 3650); //10 years
        newObj.omniData.expiresAt = now.toISOString();
        newObj.omniData.invitationStatus = "created";
        newObj.omniData.extraFields = {};
        newObj.omniData.invitationEvents = [];

        // Format phoneNumber
        newObj.omniData.userData.mobilePhone = formatPhoneNumber(obj.mobilePhone);

        invArray.push(newObj);
      }

      setImportRows([...invArray]);
    } else {
      enqueueSnackbar("Bad Columns, Aborting", {
        variant: "error",
      });
      clearState();
    }
  };

  useEffect(() => {
    if (singleInvitePagination != null) {
      setTitleText(
        `${singleInvitePagination.totalItems} Personal Invitation${
          singleInvitePagination.totalItems === 1 ? "" : "s"
        }`,
      );
    } else {
      setTitleText("Loading...");
    }

    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleInvitePagination]);

  const clearState = () => {
    setImportFile(null);
    setImportError(false);
    setImportRows([]);

    setImportResult(null);
    setImportPageNum(0);

    setCampaign("");
    setShowCampaign(false);
    setOnboardingHTML("");
    setOnboardingAssessmentType("");
    setGroupSize(null);
  };

  return (
    <Widget>
      <WidgetTitle title={"Single Invites"} text={titleText}>
        <OmniResponsiveButton
          tooltipTitle="Download bulk invite template"
          buttonText={"Template"}
          component="label"
          onClick={() => {
            fileDownload(
              // {
              //   givenName: "Given (first) Name",
              //   familyName: "Family (last) Name",
              //   mobilePhone: `${formatPhoneNumber("1234567890")}`,
              //   email: "email@email.com",
              // },
              generateCSVData([
                {
                  givenName: "Aaron",
                  familyName: "Krogh",
                  mobilePhone: `${formatPhoneNumber("5091111111")}`,
                  email: "aaron@omnisciahealth.com",
                },
                {
                  givenName: "Ricky",
                  familyName: "Lund",
                  mobilePhone: `${formatPhoneNumber("5091111111")}`,
                  email: "ricky@omnisciahealth.com",
                },
                {
                  givenName: "Melissa",
                  familyName: "Migliuri",
                  mobilePhone: `${formatPhoneNumber("5091111111")}`,
                  email: "melissa@omnisciahealth.com",
                },
                {
                  givenName: "Molly",
                  familyName: "McQuilkin",
                  mobilePhone: `${formatPhoneNumber("5091111111")}`,
                  email: "molly@omnisciahealth.com",
                },
                {
                  givenName: "Fred",
                  familyName: "Brown",
                  mobilePhone: `${formatPhoneNumber("5091111111")}`,
                  email: "fred@omnisciahealth.com",
                },
              ]),
              `inviteImportTemplate.csv`,
            );
          }}
          icon={<FileDownloadRoundedIcon />}
        ></OmniResponsiveButton>
        <OmniResponsiveButton
          tooltipTitle="Import csv file to create personal invites"
          buttonText={!importFile ? "Import" : "Importing..."}
          disabled={importFile}
          component="label"
          icon={!importFile ? <FileUploadRoundedIcon /> : <AutorenewRoundedIcon />}
        >
          <input
            disabled={importFile}
            type={"file"}
            id={"csvFileInput"}
            accept={".csv"}
            hidden={true}
            onChange={handleOnImportFileSelected}
          />
        </OmniResponsiveButton>
        <OmniResponsiveButton
          tooltipTitle="Create A Personal Invite"
          component="label"
          buttonText={"Create"}
          onClick={() => {
            let selectedInvite = createNewInvite(constants.onboardingUserType.partner);
            selectedInvite.omniData.inviteType = constants.inviteType.single;
            setSelectedInvite(selectedInvite);
          }}
        ></OmniResponsiveButton>
      </WidgetTitle>
      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyInvites
            inviteODMs={rows}
            onEditInvite={setSelectedInvite}
            onDeleteInvite={setDeleteInvite}
            onGenerateReport={setCreateReport} //set the query
            inviteSurveyType={constants.inviteSurveyType.personal}
            onRequestNewPage={loadSingleInvitesRequest}
            isLoading={singleInvitePageLoading}
            invitePagination={singleInvitePagination}
          />
        </WidgetSurveyContent>
      )}
      {createReport && <div />}
      {importError && (
        <AlertDialog
          open={importError === true}
          dialogTitle={"Import Unsuccessful"}
          dialogMessage={
            "The .csv file you tried to import didn't have the right columns or didn't contain importable data. Please check the .csv importFile for the correct headers and verify that there it contains data."
          }
          onAccept={() => {
            clearState();
          }}
          onClose={() => {
            clearState();
          }}
        />
      )}
      {deleteInvite && (
        <AlertDialog
          open={importError != null}
          dialogTitle={"Delete Confirmation"}
          dialogMessage={`Delete ${deleteInvite.omniData.userData.givenName} ${deleteInvite.omniData.userData.familyName}'s invite?`}
          onAccept={() => {
            const id = deleteInvite._id;
            setDeleteInvite(null);
            OmniDataAPI.deleteInvite(id).then(response => {
              if (response != null) {
                enqueueSnackbar("Invite Deleted Successfully.", {
                  variant: "success",
                });

                reflectUpdatedInviteODMRequest(deleteInvite);
              } else {
                enqueueSnackbar("Invite Delete Failed!", {
                  variant: "error",
                });
              }
            });
          }}
          onClose={() => {
            setDeleteInvite(null);
          }}
        />
      )}
      {deleteSelections && (
        <AlertDialog
          open={importError != null}
          dialogTitle={"Delete Confirmation"}
          dialogMessage={`Delete all ${deleteSelections.length} Invites?`}
          onAccept={() => {
            enqueueSnackbar("Deleting Invites...", {
              variant: "info",
            });
            for (let i = 0; i < deleteSelections.length; ++i) {
              const id = deleteSelections[i];
              OmniDataAPI.deleteInvite(id).then(response => {
                if (response != null) {
                  reflectUpdatedInviteODMRequest(response);
                } else {
                  enqueueSnackbar(`Delete Invites Failed!`, {
                    variant: "error",
                  });
                }
              });
            }

            setDeleteSelections(null);
          }}
          onClose={() => {
            setDeleteSelections(null);
          }}
        />
      )}
      {selectedInvite && (
        <InviteDialog
          open={selectedInvite != null}
          omniODM={selectedInvite}
          onAccept={modifiedInvite => {
            if (modifiedInvite._id == null) {
              modifiedInvite.omniData.userData.displayName = `${modifiedInvite.omniData.userData.givenName} ${modifiedInvite.omniData.userData.familyName}`;

              OmniDataAPI.createInvite(modifiedInvite).then(responseInvite => {
                if (
                  responseInvite.omniData.userType === constants.onboardingUserType.administrator
                ) {
                  OmniDataAPI.getOnboarding(responseInvite.omniData.inviteKey).then(
                    onboardingODM => {
                      onboardingODM.omniData["credentials"] = {
                        password: `${uuid()}mak3Val1d!`,
                        username: modifiedInvite.omniData.desiredUserName,
                      };

                      if (onboardingODM) {
                        props.onboardUserRequest({
                          onboardingODM: onboardingODM,
                          assessmentODM: null,
                          onboardingProctorODM: null,
                          passiveOnboard: true,
                        });
                      } else {
                        enqueueSnackbar("Onboard Failed.", {
                          variant: "error",
                        });
                      }
                    },
                  );
                } else {
                  if (responseInvite != null) {
                    enqueueSnackbar("Invite Created Successfully.", {
                      variant: "success",
                    });
                    props.reflectUpdatedInviteODMRequest(responseInvite);
                  } else {
                    enqueueSnackbar("Invite Creation Failed!", {
                      variant: "error",
                    });
                  }
                }
              });
            } else {
              OmniDataAPI.updateInvite(modifiedInvite).then(response => {
                if (response != null) {
                  enqueueSnackbar("Invite Updated Successfully.", {
                    variant: "success",
                  });
                  props.reflectUpdatedInviteODMRequest(response);
                } else {
                  enqueueSnackbar("Invite Update Failed!", {
                    variant: "error",
                  });
                }
              });
            }
            setSelectedInvite(null);
          }}
          onClose={() => {
            setSelectedInvite(null);
          }}
          onDelete={() => {
            const id = selectedInvite._id;
            OmniDataAPI.deleteInvite(id).then(response => {
              if (response != null) {
                enqueueSnackbar("Invite Deleted Successfully.", {
                  variant: "success",
                });

                reflectUpdatedInviteODMRequest(selectedInvite);
              } else {
                enqueueSnackbar("Invite Delete Failed!", {
                  variant: "error",
                });
              }
            });

            setSelectedInvite(null);
          }}
        />
      )}
      {showCampaign && (
        <BulkInviteDialog
          dialogTitle="Creation Settings"
          open={showCampaign != null}
          onAccept={theResponse => {
            setOnboardingHTML(theResponse.onboardingHTML);
            setOnboardingAssessmentType(theResponse.onboardingAssessmentType);
            setCampaign(theResponse.target);
            setGroupSize(theResponse.groupSize);
            setShowCampaign(false);
          }}
          onClose={() => {
            clearState();
            setShowCampaign(false);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  singleInviteODMs: state.adminSession.singleInviteODMs,
  singleInvitePageLoading: state.adminSession.singleInvitePageLoading,
  singleInvitePagination: state.adminSession.singleInvitePagination,

  onboardingStatus: state.onboardingSession.onboardingStatus,
});

const mapDispatchToProps = {
  loadSingleInvitesRequest: AdminSessionActions.loadSingleInvitesRequest,
  reflectUpdatedInviteODMRequest: AdminSessionActions.reflectUpdatedInviteODMRequest,
  onboardUserRequest: OnboardingSessionActions.onboardUserRequest,
  setOnboardingStatusRequest: OnboardingSessionActions.setOnboardingStatusRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminSingleInvites));
